import React from 'react';
import { Button } from '../ui/button';
import { AlertCircle, Sparkles, X } from 'lucide-react';
interface CreditWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  creditsNeeded: number;
  estimatedTotal: number;
}
export function CreditWarningModal({
  isOpen,
  onClose,
  onConfirm,
  creditsNeeded,
  estimatedTotal
}: CreditWarningModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1062">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-1063" />

      {/* Modal */}
      <div className="relative bg-card border border-border rounded-xl shadow-lg max-w-md w-full p-6 animate-in fade-in zoom-in duration-200" data-id="element-1064">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors" data-id="element-1065">
          <X size={20} data-id="element-1066" />
        </button>

        {/* Header */}
        <div className="flex items-center gap-3 mb-4" data-id="element-1067">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-1068">
            <Sparkles size={24} className="text-primary" data-id="element-1069" />
          </div>
          <div data-id="element-1070">
            <h2 className="text-xl font-semibold" data-id="element-1071">Confirm Comment Fetch</h2>
            <p className="text-sm text-muted-foreground" data-id="element-1072">
              Review before proceeding
            </p>
          </div>
        </div>

        {/* Info */}
        <div className="space-y-3 mb-6" data-id="element-1073">
          <div className="p-4 bg-secondary/30 rounded-lg" data-id="element-1074">
            <div className="flex items-center justify-between mb-2" data-id="element-1075">
              <span className="text-sm text-muted-foreground" data-id="element-1076">
                Total Comments
              </span>
              <span className="text-lg font-semibold" data-id="element-1077">
                {estimatedTotal.toLocaleString()}
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-1078">
              <span className="text-sm text-muted-foreground" data-id="element-1079">
                Credits Required
              </span>
              <span className="text-lg font-semibold text-primary" data-id="element-1080">
                {creditsNeeded}
              </span>
            </div>
          </div>

          <div className="p-3 bg-blue-500/10 border border-blue-500/20 rounded-lg" data-id="element-1081">
            <div className="flex items-start gap-2" data-id="element-1082">
              <AlertCircle size={16} className="text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" data-id="element-1083" />
              <div className="text-xs text-blue-600 dark:text-blue-400" data-id="element-1084">
                <p className="font-medium mb-1" data-id="element-1085">How credits work:</p>
                <ul className="space-y-1 list-disc list-inside" data-id="element-1086">
                  <li data-id="element-1087">1 credit per 100 comments</li>
                  <li data-id="element-1088">Charged based on actual comments fetched</li>
                  <li data-id="element-1089">Partial refund if fetch fails</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3" data-id="element-1090">
          <Button onClick={onClose} variant="outline" className="flex-1" size="sm" data-id="element-1091">
            Cancel
          </Button>
          <Button onClick={onConfirm} className="flex-1" size="sm" data-id="element-1092">
            Confirm ({creditsNeeded}{' '}
            {creditsNeeded === 1 ? 'credit' : 'credits'})
          </Button>
        </div>
      </div>
    </div>;
}